import { useQuery, useMutation } from "@tanstack/react-query";
import { api } from "@/utils/axiosInterceptor";
import { JobCode, JobCodeFormData } from "@/types/jobCode";

export const useJobCode = () => {
	const {
		data: jobCode,
		isLoading,
		error,
	} = useQuery({
		queryKey: ["jobCode"],
		queryFn: async () => {
			const response = await api.get<JobCode[]>("/job-code")
			return response.data;
		},
	});

	const createJobCodeMutation = useMutation({
		mutationFn: (jobCode: Omit<JobCodeFormData, "id">) => api.post<JobCodeFormData>("/job-code", jobCode),
	});

	const updateJobCodeMutation = useMutation({
		mutationFn: (jobCode: {id: string | undefined, body: Partial<JobCodeFormData>}) =>
			api.put<JobCodeFormData>(`/job-code/${jobCode.id}`, jobCode.body),
	});

	const deleteJobCodeMutation = useMutation({
		mutationFn: (id: string) => api.delete(`/job-code/${id}`),
	});

	return {
		jobCode,
		createJobCodeAsync: createJobCodeMutation.mutateAsync,
		isCreating: createJobCodeMutation.isPending,
		updateJobCode: updateJobCodeMutation.mutateAsync,
		isUpdating: updateJobCodeMutation.isPending,
		deleteJobCodeAsync: deleteJobCodeMutation.mutateAsync,
		isLoading,
		error,
	};
};
